<template>
    <div class="quesDetail">
        <el-row>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-page-header @back="goBack" content="问题详情"></el-page-header>
                </div>
                <div class="content">
                    <el-descriptions class="margin-top" :column="1" size="medium" border :labelStyle="labelStyle" :contentStyle="contentStyle">
                        <el-descriptions-item label-class-name="my-label">
                            <template slot="label">
                                问题题目:
                            </template>
                            {{ qsData.title }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                型号:
                            </template>
                            {{ qsData.goods_model }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                最后修改时间:
                            </template>
                            {{ qsData.create_time }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                入库人:
                            </template>
                            {{ qsData.publish_person_name }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                工单类型:
                            </template>
                            <el-tag size="small">{{ qsData.type }}</el-tag>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item>
                            <template slot="label">
                                图片:
                            </template>
                            <div style="display: flex;">
                                <div class="img" v-for="item in imgList" :key="item.id">
                                    <el-image
                                        style="width: 60px; height: 60px;margin-left: 10px;"
                                        :src="item.url"
                                        :preview-src-list="imgArr">
                                    </el-image>
                                </div>
                            </div>
                        </el-descriptions-item> -->
                        <el-descriptions-item>
                            <template slot="label">
                                文件:
                            </template>
                            <div class="file">
                                <a v-for="val in fileList" :key="val.id" @click="downLoadFile(val.url)" style="display: flex;">
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='txt'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/txt.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='ppt' || val.url.split('.')[val.url.split('.').length-1] ==  'pptx'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/ppt.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='pdf'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/pdf.png')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='xlsx' || val.url.split('.')[val.url.split('.').length-1]=='xls'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/excel.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='docx' || val.url.split('.')[val.url.split('.').length-1]=='doc'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/word.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='avi'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/avi.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='7z' || val.url.split('.')[val.url.split('.').length-1]=='rar'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/zip.png')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                    <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='mp4' || val.url.split('.')[val.url.split('.').length-1]=='mov' ||val.url.split('.')[val.url.split('.').length-1]=='ogg' || val.url.split('.')[val.url.split('.').length-1]=='webm'">
                                        <div>                                    
                                            <el-image :src = "require('../assets/filetype/video.jpg')"></el-image>
                                        </div>
                                        <div class="name">{{ val.name }}</div>
                                    </div>
                                </a>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>

                <div class="detail">
                    <div class="title">详情</div>
                    <el-divider></el-divider>
                    <div class="content" v-html="qsData.detail"></div>
                </div>

            </el-card>
        </el-row>
        <el-dialog
          :title="videoTitle"
          :visible.sync="videVisible"
          width="40%">
          <video v-if="videVisible" width="100%" controls>
              <source :src="videoSrc" type="video/mp4">
          </video>
        </el-dialog>
    </div>
</template>

<script>
import { quesDetail,updateTable } from '../utils/api'
export default {
    components: {},
    props: {},
    data() {
        return {
            id: '',
            videoSrc:'',
            videVisible:false,
            videoTitle:'',
            qsData: {},
            imgList:[],
            imgArr:[],
            fileList:[],
            updateTable:[],
            labelStyle:{
              width:'150px',
              background:'#fff',
              color:'#333'
            },
            contentStyle:{
              color:'#999'
            },
            urlHerf:localStorage.getItem('urlHerf')
        };
    },
    watch: {},
    computed: {},
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        // 下载文件列表
        downLoadFile(val){
            if(val.split('.')[val.split('.').length-1]=='mp4'){
                console.log(val,'valvalvalvalvalval');
                return this.watchEvent(val)
            }
          let link = document.createElement("a")
          link.style.display = "none"
          link.href = val
          var arr = val.split("/")
          link.setAttribute("download",arr[arr.length-1])
          document.body.appendChild(link)
          link.click()
        },
        getQs() {
            var tempurl = window.location.hash
            var jumpId = tempurl.split('?')[1].split('=')[1]
            console.log(jumpId, 'kklkk')
            this.id = Number(jumpId)
            var params = {
                id: this.id
            }
            quesDetail(params)
                .then(res => {
                    console.log(res, 'res');
                    if (res.message.status == 'success') {
                        this.qsData = res.data
                        this.qsData.create_time = this.getTimeship(this.qsData.create_time)
                        //图片
                        console.log(this.qsData.attach_image_info.length,'this.qsData.attach_image_info');
                        var imgList = []
                        var arr = []
                        this.imgList = []
                        imgList = this.qsData.attach_image_info
                        imgList.forEach(item=>{
                            item.url = this.urlHerf + item.url
                            arr.push(item)
                            this.imgArr.push(item.url)
                        })
                        this.imgList = arr
                        console.log(this.imgList,'this.imgList');

                        //文件
                        // console.log(this.qsData.attach_file_info.length,'this.qsData.attach_file_info.length');
                        var fileArr = this.qsData.attach_file_info
                        var arr1 = []
                        fileArr.forEach(ele =>{
                            ele.url = this.urlHerf + ele.url
                            arr1.push(ele)
                        })
                        this.fileList = arr1
                        console.log(this.fileList,'this.fileList');
                    } else {
                        this.$message.error(res.message.text)
                    }
                })
                .catch(err => {
                    console.log(err, 'err');
                })
        },
        getupdateTable(){
            var that = this
            var params = {
                question_id:this.id
            }
            updateTable(params)
            .then(res=>{
                console.log(res,'修改记录');
                if(res.message.status == 'success'){
                    that.updateTable = res.data
                    that.updateTable.forEach(item=>{
                        item.create_time = that.getTimeship(item.create_time)
                    })
                }
            })
            .catch(err=>{
                console.log(err,'err');
            })
        },
        //视频
        watchEvent(val){
          console.log(val,'val');
          this.videVisible = true
          this.videoSrc = val
          this.videoTitle = val.name
        },


    },
    created() { },
    mounted() { },
    activated() {
        this.getQs()
        // this.getupdateTable()
    }
};
</script>
<style lang="scss" scoped>
.updateTable{
    width: 100%;
    height: 100%;
    margin-top: 50px;

    .titTop{
        font-size: 18px;
        color: #303133;
    }

    .mains{
        width: 100%;
        margin-top: 20px;
        .title{
            color: #666;
            font-weight: 600;
            font-size: 16px;
            .sp{
                margin-left: 10px;
            }
        }
        :deep(.content){
            margin-top: 10px;
            font-size: 14px;
            color: #666;

            img{
                width: 100%;
            }
        }
    }
}

.detail{
    margin-top: 20px;
    .title{
        font-size: 18px;
    }
    .content{
        // border: 1px solid #e4e4e4;
        background: #f4f4f4;
        padding: 10px;
        border-radius: 5px;
        overflow-x: scroll;
    }
}
.file{
    display: flex;
    a{
        width: 60px;
        margin-left: 5px;
        .item{
            width: 100%;
            font-size: 12px;
            .name{
                display:block;             /*内联对象需加*/
                width:100%;
                word-break:keep-all;       /* 不换行 */
                white-space:nowrap;        /* 不换行 */
                overflow:hidden;           /* 内容超出宽度时隐藏超出部分的内容 */
                text-overflow:ellipsis;    /*溢出时显示省略标记...；需与overflow:hidden;一起使用*/
            }
            .el-image{
                width: 100%;
            }
        }
    }
}
</style>